import { render, staticRenderFns } from "./UserAdminManage.vue?vue&type=template&id=65438ddf&"
import script from "./UserAdminManage.vue?vue&type=script&lang=js&"
export * from "./UserAdminManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports